import React from 'react';
import BlogBanner from '../../resources/asial_tech_blog_logo_footer.svg';
import NoteBanner from '../../resources/asial_note_logo_footer.svg';

import { EXTERNAL_URL, STATIC_SITE_MAP } from '../../consts/asial-websites-sitemap.const';
import originalStyles from '../../styles/asial-website-footer.module.scss';
import portalStyles from '../../styles/asial-website-footer-portal.module.scss';
import cn from 'classnames';
import { extractStyle } from '../../styles/styles-extract-util';

export const AsialWebsiteFooterPortal: React.FC = () => {
  const baseStyles = extractStyle(originalStyles);
  const portal = extractStyle(portalStyles);
  const styles = { ...baseStyles, ...portal };
  return (
    <div className={cn(styles['portal-wrapper'], styles['base-grid'], 'base-grid')}>
      <div className={cn(styles['portal-container'], styles['base-grid'], 'base-grid')}>
        <div className={styles['portal-top']}>
          <span className={styles['message']}>Asialの発信や<br className='sp-only'/>ニュースをチェック</span>
          <a href="https://www.facebook.com/asial.co.jp/" target="_blank">
            <div className={styles['facebook-icon']}>
              <svg width="25" height="47" viewBox="0 0 25 47" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.2885 26.3828L24.5742 18H16.5312V12.5602C16.5312 10.2669 17.655 8.03125 21.2573 8.03125H24.9141V0.894531C24.9141 0.894531 21.5955 0.328125 18.4225 0.328125C11.7984 0.328125 7.46875 4.34281 7.46875 11.6109V18H0.105469V26.3828H7.46875V46.6477C8.94537 46.8794 10.4582 47 12 47C13.5418 47 15.0546 46.8794 16.5312 46.6477V26.3828H23.2885Z" />
              </svg>
            </div>
          </a>
          <a href="https://twitter.com/asialnews/" target="_blank">
            <div className={styles['twitter-icon']}>
              <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.8541 12.703L29.0223 0H26.3758L16.6784 11.0298L8.9332 0H0L11.7123 16.679L0 30H2.64665L12.8873 18.3522L21.0668 30H30L17.8534 12.703H17.8541ZM14.2291 16.8259L13.0424 15.1651L3.60028 1.94952H7.66537L15.2853 12.6149L16.472 14.2758L26.377 28.1391H22.3119L14.2291 16.8266V16.8259Z" />
              </svg>
            </div>
          </a>
          <a href={STATIC_SITE_MAP.SUBSCRIBE.path} target="_blank">
            <div className={styles['mail-icon']}>
              <svg width="32" height="24" viewBox="0 0 32 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M28.3547 0.413795H3.64531C1.78087 0.413795 0.275848 1.9617 0.275848 3.87926V20.1207C0.275848 22.0383 1.78087 23.5862 3.64531 23.5862H28.3547C30.2191 23.5862 31.7241 22.0383 31.7241 20.1207V3.87926C31.7241 1.9617 30.2191 0.413795 28.3547 0.413795ZM28.3547 2.72411C28.3547 2.72411 28.5119 2.74721 28.5793 2.77031L18.3811 13.2591C17.0782 14.5991 14.9442 14.5991 13.6189 13.2591L3.42068 2.77031C3.42068 2.77031 3.55545 2.72411 3.64531 2.72411H28.3547ZM28.3547 21.2759H3.64531C3.0388 21.2759 2.52215 20.7676 2.52215 20.1207V5.10373L12.024 14.8763C13.1247 16.0084 14.5624 16.5629 16 16.5629C17.4376 16.5629 18.8753 16.0084 19.9535 14.8763L29.4778 5.10373V20.1207C29.4778 20.7676 28.9836 21.2759 28.3547 21.2759Z" />
              </svg>
            </div>
          </a>
        </div>
        <div className={styles['portal-bottom']}>
          <div className={styles['blog']}>
            <a href={EXTERNAL_URL.ASIAL_BLOG} target="_blank">
              <img src={BlogBanner} alt="アシアルTechブログ" />
            </a>
            <p>
              アシアルの中の人が
              <br className={styles['sp-br']} />
              技術と想いのたけをつづるブログ
            </p>
          </div>
          <div className={styles['note']}>
            <a href={EXTERNAL_URL.ASIAL_NOTE} target="_blank">
              <img src={NoteBanner} alt="アシアルnote" />
            </a>
            <p>
              日々の活動や取り組み、
              <br className={styles['sp-br']} />
              アシアルのカルチャーを紹介
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
